<template>
    <div class="full-page-wrapper">
        <div class="resume-card">
            <GallabLogo />
            <h2>Masz niedokończoną konfigurację</h2>
            <p>Czy chcesz kontynuować tam, gdzie przerwałeś?</p>
            <div class="resume-actions">
                <button class="save-button" @click="onContinue">Tak, kontynuuj</button>
                <button class="cancel-button" @click="onCancel">Nie, zacznij od nowa</button>
            </div>
        </div>
    </div>
</template>

<script>
import GallabLogo from '@/components/common/GallabLogo.vue'

export default {
    emits: ['continue', 'cancel'],
    components: {
        GallabLogo
    },
    methods: {
        onContinue() {
            this.$router.push('/configurator');
            this.$emit('continue');
        },
    onCancel() {
            this.$router.push('/');
            this.$emit('cancel');
        }
    }
};
</script>

<style scoped lang="scss">
.full-page-wrapper {
    position: fixed;
    inset: 0;
    background-color: $color-background;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.resume-card {
    background: $color-white;
    padding: 40px 30px;
    border-radius: 12px;
    max-width: 500px;
    width: 90%;
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.2);
    text-align: center;

    h2 {
        font-size: 1.5rem;
        margin-bottom: 10px;
        color: $color-text;
    }

    p {
        font-size: 1rem;
        color: $color-text-light;
    }
}

.resume-actions {
    display: flex;
    gap: 15px;
    padding-top: 20px;

    button {
        flex: 1;
        padding: 12px;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        font-size: 1rem;
        font-weight: 500;
        transition: all 0.3s ease;
    }

    .save-button {
        background-color: $color-primary;
        color: $color-white;

        &:hover {
            background-color: $color-primary-dark;
        }
    }

    .cancel-button {
        background-color: $color-grey;
        color: $color-text;

        &:hover {
            background-color: $color-grey-dark;
        }
    }

    @media (max-width: 768px) {
        flex-direction: column;

        button {
            width: 100%;
        }
    }
}
</style>